import React, { useEffect, useState } from 'react';
import { ShieldOff, ShieldCheck, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';
import { toast } from '../../hooks/use-toast';
import api from '../../services/api';

export const PortalBulkButtons = ({ onDone }) => {
  const [stat, setStat] = useState(null);
  const [ask, setAsk] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get('/api/employees/portal/bulk-status').then((r) => setStat(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post('/api/employees/portal/bulk', { active: ask === 'on' });
      toast({ title: r.data.message });
      onDone?.();
    } catch (e) {
      toast({ title: 'Failed', description: e.response?.data?.detail || 'Could not update portal access', variant: 'destructive' });
    } finally { setBusy(false); setAsk(null); load(); }
  };

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setAsk('off')} disabled={!stat?.active}
        className="border-rose-200 text-rose-700 hover:bg-rose-50 gap-1.5" data-testid="portal-deactivate-all-btn">
        <ShieldOff className="h-3.5 w-3.5" /> Deactivate all portals
      </Button>
      <Button variant="outline" size="sm" onClick={() => setAsk('on')} disabled={!stat?.bulk_off}
        className="border-emerald-200 text-emerald-700 hover:bg-emerald-50 gap-1.5" data-testid="portal-reactivate-all-btn">
        <ShieldCheck className="h-3.5 w-3.5" /> Reactivate all{stat?.bulk_off ? ` (${stat.bulk_off})` : ''}
      </Button>
      <AlertDialog open={!!ask} onOpenChange={(o) => !o && setAsk(null)}>
        <AlertDialogContent data-testid="portal-bulk-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{ask === 'off' ? 'Deactivate the Employee Portal for all staff?' : 'Reactivate the Employee Portal?'}</AlertDialogTitle>
            <AlertDialogDescription>
              {ask === 'off'
                ? `${stat?.active || 0} staff will be signed out and unable to log in to the Employee Portal until you reactivate them.`
                : `${stat?.bulk_off || 0} staff switched off by "Deactivate all" will get portal access back. Staff you deactivated individually stay off.`}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="portal-bulk-cancel">No</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); run(); }} disabled={busy}
              className={ask === 'off' ? 'bg-rose-600 hover:bg-rose-700' : 'bg-emerald-600 hover:bg-emerald-700'} data-testid="portal-bulk-confirm">
              {busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />} Yes
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
